const AgeMapping: Record<string, string> = {
    C1: '0-3',
    C2: '4-6',
    C3: '7-9',
    C4: '10-12',
    C5: '13-15',
    C6: '16-17',
};

export default AgeMapping;
